module.exports = __webpack_public_path__ + "img/c07_unittechthrowingaxemanchampion_Normal_ua.1dd8798b.webp";